"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextInputField = void 0;
const react_1 = __importDefault(require("react"));
const TextInputField_styles_1 = require("./TextInputField.styles");
const TextInputField = (_a) => {
    var { value, unit, onChange, errorText, warningText, disabled, enableHotJar } = _a, rest = __rest(_a, ["value", "unit", "onChange", "errorText", "warningText", "disabled", "enableHotJar"]);
    return (react_1.default.createElement(TextInputField_styles_1.InputWrapper, null,
        react_1.default.createElement(TextInputField_styles_1.InputGroup, null,
            react_1.default.createElement(TextInputField_styles_1.Input, Object.assign({ value: value, onChange: (e) => onChange(e.target.value), type: "text", "$hasError": !!errorText, "$hasWarning": !!warningText, disabled: !!disabled, className: enableHotJar ? "data-hj-allow" : undefined }, rest)),
            react_1.default.createElement(TextInputField_styles_1.UnitWrapper, { "$hasError": !!errorText, "$hasWarning": !!warningText, disabled: !!disabled }, unit))));
};
exports.TextInputField = TextInputField;
//# sourceMappingURL=TextInputField.js.map